import { Entity, EntityMap, HidableFeedType, PinnableFeedType } from '../types';

export type RequestStatusType =
  | 'AddFavoriteGroup'
  | 'AddThreadTopic'
  | 'AllNetworkGroupsLoadMore'
  | 'AppViewProperties'
  | 'AppViewPropertiesSet'
  | 'ArchiveTeamsMeetingFeed'
  | 'AudienceMembersLoad'
  | 'Campaign'
  | 'CampaignPinnedResourcesPinLink'
  | 'CampaignEdit'
  | 'CampaignPublish'
  | 'CampaignDelete'
  | 'CampaignFollow'
  | 'CampaignsListMore'
  | 'CampaignUnfollow'
  | 'CampaignGoalTracker'
  | 'CampaignSash'
  | 'CampaignGoalTrackerCreate'
  | 'CampaignGoalTrackerEdit'
  | 'CampaignSash'
  | 'CancelEvent'
  | 'CancelGenerateCuratedThreads'
  | 'CoverImageDelete'
  | 'CoverImageUpload'
  | 'CheckSharePointVideoAccess'
  | 'CreateAudience'
  | 'CreateAudienceFromDirectMembers'
  | 'CreateAudienceFromOfficeGroup'
  | 'CreateCalendarInviteForTeamsMeeting'
  | 'CreateGroupCalendarInviteForBroadcast'
  | 'CreateTeamsMeeting'
  | 'DelegationRemove'
  | 'DelegationAdd'
  | 'DelegationEdit'
  | 'DeleteDraftThreads'
  | 'DeleteFile'
  | 'DeleteMessage'
  | 'DeleteTeamsMeeting'
  | 'DeleteThread'
  | 'DesignateLeader'
  | 'DesignateLeadersFromOfficeGroupAsyncAction'
  | 'DownloadIcs'
  | 'EditAudience'
  | 'EditEvent'
  | 'EditNetworkQuestionInfoPanel'
  | 'EditNetworkQuestionSettings'
  | 'EditInformationBarrierAdminSettings'
  | 'EditRestrictedPosting'
  | 'EditTeamsMeeting'
  | 'EditNetworkUsagePolicy'
  | 'EditTenantConfigurationSettings'
  | 'EditUserAchievementAdminSettings'
  | 'EditUserAchievementUserSettings'
  | 'EventLoadByBroadcastId'
  | 'FeatureNotImplemented'
  | 'FeedLoadNewerThreads'
  | 'FeedLoadOlderThreads'
  | 'GoalsOrganizationsLoad'
  | 'GoalsOrganizationLoadById'
  | 'GoalsOrganizationTeamsLoadMore'
  | 'GoalsTeamsLoad'
  | 'GroupAddUserByEmail'
  | 'GroupAddUser'
  | 'GroupAvatarUpload'
  | 'GroupDelete'
  | 'GroupDiscoverySettingsLoad'
  | 'GroupEdit'
  | 'GroupEventsSidebarLoad'
  | 'GroupFeedUnreadCount'
  | 'GroupHideForNetworkInDiscovery'
  | 'GroupHideForViewerInDiscovery'
  | 'GroupLeaderAdd'
  | 'GroupLeaderRemove'
  | 'GroupLeaderAddRemove'
  | 'GroupMembersBulkUpload'
  | 'GroupMemberPanelPaginations'
  | 'GroupUnhideForNetworkInDiscovery'
  | 'GroupUnhideForViewerInDiscovery'
  | 'GroupPinnedResourcesPinLink'
  | 'GroupResolveMembership'
  | 'GroupMakeAdmin'
  | 'GroupRevokeAdmin'
  | 'GroupRemoveUser'
  | 'InboxUnreadCount'
  | 'UserInformationBarrierSettings'
  | 'LiveEventsLoadByNetwork'
  | 'LoadMoreGoals'
  | 'M365CopilotGroupSuggestedMembersBulkAdd'
  | 'MarkAllNotificationsAsSeen'
  | 'MarkAllGroupThreadsAsSeen'
  | 'MarkUserDefaultAudience'
  | 'MarkMultiTenantOrganizationGroup'
  | 'MessageUpvotesLoadMore'
  | 'ModerateThread'
  | 'MyGroupsLoadMore'
  | 'NotificationLoadMore'
  | 'NotificationUnseenCountLoad'
  | 'OfficeTopicLoadAuthorized'
  | 'OfficialGroupsLoadMore'
  | 'PinnedResourcesPinLink'
  | 'PollClose'
  | 'PollReopen'
  | 'PollLoad'
  | 'PollVote'
  | 'PromoteThread'
  | 'PublishMessage'
  | 'ReactionAccentColorUpdate'
  | 'RemoveFromDirectAudience'
  | 'RemoveLeaderAudience'
  | 'RemoveThreadTopic'
  | 'RemoveTopic'
  | 'ReportMessage'
  | 'ResolveCampaignWeblink'
  | 'RevokeLeader'
  | 'SearchLoadMore'
  | 'SecondLevelRepliesLoadNext'
  | 'SecondLevelRepliesLoadPrevious'
  | 'SecondLevelRepliesLoadLast'
  | 'SharePointVideoPreviewUrlLoad'
  | 'SuggestedTopicsLoadMore'
  | 'TenantConfigurationAndRoles'
  | 'TeamsMeetingFeedLoad'
  | 'TeamsMeetingsByOrganizerLoad'
  | 'ThreadArchiveFromTeamsMeetingFeed'
  | 'ThreadBookmark'
  | 'ThreadClose'
  | 'ThreadHideFromCampaignFeed'
  | 'ThreadLoadNewerReplies'
  | 'ThreadListLoad'
  | 'ThreadMarkAsQuestion'
  | 'ThreadMove'
  | 'ThreadMuteConversation'
  | 'ThreadPinToCampaignFeed'
  | 'ThreadPinToEventFeed'
  | 'ThreadPinToGroupFeed'
  | 'ThreadPinToMyLeadersFeed'
  | 'ThreadPinToTeamsMeetingFeed'
  | 'ThreadPinToUserStorylineFeed'
  | 'ThreadRemoveParticipants'
  | 'ThreadReopen'
  | 'ThreadUnarchiveFromTeamsMeetingFeed'
  | 'ThreadsAppliedTopicNames'
  | 'ThreadShareLoad'
  | 'ThreadUnmuteConversation'
  | 'ThreadUnbookmark'
  | 'ThreadUnmarkAsQuestion'
  | 'ThreadUnpinFromCampaignFeed'
  | 'ThreadUnpinFromEventFeed'
  | 'ThreadUnpinFromGroupFeed'
  | 'ThreadUnpinFromMyLeadersFeed'
  | 'ThreadUnpinFromTeamsMeetingFeed'
  | 'ThreadUnpinFromUserStorylineFeed'
  | 'TopicCreate'
  | 'TopicCurate'
  | 'TopicUncurate'
  | 'TopicFollowersPagination'
  | 'TopLevelRepliesLoadInitialReplies'
  | 'TopLevelRepliesLoadLast'
  | 'TopLevelRepliesLoadNext'
  | 'TopLevelRepliesLoadPrevious'
  | 'TopicEdit'
  | 'TopicsAllLoad'
  | 'TopicsAllLoadMore'
  | 'TopicsFollowedLoadMore'
  | 'TrendingTopicsLoadMore'
  | 'WebLinkResolve'
  | 'UnmarkMultiTenantOrganizationGroup'
  | 'UnpromoteThread'
  | 'UnseenThreadsLoad'
  | 'UpdateHasNetworkWideAudience'
  | 'UpdateCollaboratorsForDraftThread'
  | 'UpdateHasMultiTenantWideAudience'
  | 'UserConnectedLeadersListLoadMore'
  | 'UserFollowedLeadersListLoadMore'
  | 'UserNetworkLeadersListMore'
  | 'UserDirectAudienceLoadMore'
  | 'UpdateInformationBarrierAdminSettings'
  | 'UpdatePinnedGoalsForGroup'
  | 'UpdateUserAdminRoles'
  | 'UpdateUserPreferences'
  | 'UpdateStorylineDefaultNotificationDeliverySettings'
  | 'UpdateStorylinePerUserControlSettings'
  | 'UpdateStorylineMTOAdminSettings'
  | 'UploadTenantLogo';

export type HideRequestStatusType = 'ThreadHideFromCampaignFeed';

export type PinRequestStatusType =
  | 'ThreadPinToCampaignFeed'
  | 'ThreadPinToEventFeed'
  | 'ThreadPinToMyLeadersFeed'
  | 'ThreadPinToGroupFeed'
  | 'ThreadPinToTeamsMeetingFeed'
  | 'ThreadPinToUserStorylineFeed';

export type UnpinRequestStatusType =
  | 'ThreadUnpinFromCampaignFeed'
  | 'ThreadUnpinFromEventFeed'
  | 'ThreadUnpinFromGroupFeed'
  | 'ThreadUnpinFromMyLeadersFeed'
  | 'ThreadUnpinFromTeamsMeetingFeed'
  | 'ThreadUnpinFromUserStorylineFeed';

export const liveEventsLoadByNetworkRequestId = 'liveEventsLoadByNetwork';
export const notificationUnseenCountRequestId = 'notificationUnseenCount';
export const inboxUnreadCountRequestId = 'inboxUnreadCountRequestId';
export const addFavoriteGroupRequestId = 'addFavoriteRejected';
export const updateReactionAccentColorRequestId = 'updateReactionAccentColor';
export const removeUserDelegateRequestId = 'removeUserDelegateRequestId';
export const threadListLoadRequestId = 'threadListLoadRequestId';
export const topicsAllLoadRequestId = 'topicsAllLoadRequestId';
export const topicsAllLoadMoreRequestId = 'topicsAllLoadMoreRequestId';
export const editTenantConfigurationSettingsRequestId = 'editTenantConfigurationSettingsRequestId';
export const editNetworkUsagePolicyRequestId = 'editNetworkUsagePolicyRequestId';
export const addUserDelegateRequestId = 'addUserDelegateRequestId';
export const editUserDelegateRequestId = 'editUserDelegateRequestId';
export const editNetworkQuestionInfoPanelRequestId = 'editNetworkQuestionInfoPanelRequestId';
export const editNetworkQuestionsSettingsRequestId = 'editNetworkQuestionsSettingsRequestId';
export const editInformationBarrierAdminSettingsRequestId = 'editInformationBarrierAdminSettingsRequestId';
export const updateStorylineDefaultNotificationDeliverySettingsRequestId =
  'updateStorylineDefaultNotificationDeliverySettingsRequestId';
export const updateStorylinePerUserControlSettingsRequestId = 'updateStorylinePerUserControlSettingsRequestId';
export const updateStorylineMtoAdminSettingsRequestId = 'updateStorylineMtoAdminSettingsRequestId';
export const uploadTenantLogoRequestId = 'uploadTenantLogoRequestId';
export const suggestedTopicsLoadMoreRequestId = 'suggestedTopicsLoadMoreRequestId';
export const officialGroupsLoadMoreRequestId = 'officialGroupsLoadMoreRequestId';
export const updateHasMultiTenantWideAudienceRequestId = 'updateHasMultiTenantWideAudienceRequestId';
export const goalsOrganizationsLoadRequestId = 'goalsOrganizationsLoadRequestId';
export const tenantConfigurationAndRolesRequestId = 'tenantConfigurationAndRolesRequestId';

export interface RequestStatus extends Entity {
  readonly fulfilledTime: number;
}

export type RequestStatuses = EntityMap<RequestStatus>;

const hideRequestTypeMap: Record<HidableFeedType, HideRequestStatusType> = {
  Campaign: 'ThreadHideFromCampaignFeed',
};

const pinRequestTypeMap: Record<PinnableFeedType, PinRequestStatusType> = {
  Campaign: 'ThreadPinToCampaignFeed',
  Group: 'ThreadPinToGroupFeed',
  LiveEvent: 'ThreadPinToEventFeed',
  MyLeaders: 'ThreadPinToMyLeadersFeed',
  TeamsMeeting: 'ThreadPinToTeamsMeetingFeed',
  UserWall: 'ThreadPinToUserStorylineFeed',
};

const unpinRequestTypeMap: Record<PinnableFeedType, UnpinRequestStatusType> = {
  Campaign: 'ThreadUnpinFromCampaignFeed',
  Group: 'ThreadUnpinFromGroupFeed',
  LiveEvent: 'ThreadUnpinFromEventFeed',
  MyLeaders: 'ThreadUnpinFromMyLeadersFeed',
  TeamsMeeting: 'ThreadUnpinFromTeamsMeetingFeed',
  UserWall: 'ThreadUnpinFromUserStorylineFeed',
};

type GetPinRequestStatusType = (targetFeedType?: PinnableFeedType) => PinRequestStatusType | undefined;
export const getPinRequestStatusType: GetPinRequestStatusType = (targetFeedType) =>
  targetFeedType ? pinRequestTypeMap[targetFeedType] : undefined;

type GetHideRequestStatusType = (targetFeedType?: HidableFeedType) => HideRequestStatusType | undefined;
export const getHideRequestStatusType: GetHideRequestStatusType = (targetFeedType) =>
  targetFeedType ? hideRequestTypeMap[targetFeedType] : undefined;

type GetUnpinRequestStatusType = (targetFeedType?: PinnableFeedType) => UnpinRequestStatusType | undefined;
export const getUnpinRequestStatusType: GetUnpinRequestStatusType = (targetFeedType) =>
  targetFeedType ? unpinRequestTypeMap[targetFeedType] : undefined;
